// extracted by mini-css-extract-plugin
module.exports = {"overviewMetricsStyle":"_20R8ufYErNXUlSL41tkDPR"};